import { Checkbox, Col, Row } from 'antd';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';

import SubHeader from '../../../../../components/SubHeader';
import { hasValueInList } from '../../../../../helpers/array';
import PermissoesHelper from '../../../../../helpers/PermissoesHelper';
import { Card, LabelCheckbox, SubTitleCard, TitleSubGroup } from './styles';

export default function Notificacao({
  selectedPermissions,
  onSelectPermission,
  isEditing,
}) {
  const [permissoesExistentes, setPermissoesExistentes] = useState({});

  useEffect(() => {
    async function getPermissoes() {
      const permissoes = await PermissoesHelper.getPermissoesAgrupadas(true);
      setPermissoesExistentes(permissoes);
    }

    getPermissoes();
  }, []);

  return (
    <Col xs={24} lg={24} xl={24} className="mt-20">
      <SubHeader title="Notificações" />
      {Object.keys(permissoesExistentes).map(grupo => (
        <Col className="padding" span={24} key={grupo}>
          <SubTitleCard>{grupo}</SubTitleCard>
          <Card>
            {Object.keys(permissoesExistentes[grupo]).map(subGrupo => (
              <Col className="col-card" key={subGrupo} span={24}>
                <Row>
                  <Col span={24} className="mb-10">
                    <TitleSubGroup>{subGrupo}</TitleSubGroup>
                  </Col>
                  {permissoesExistentes[grupo][subGrupo].map(({ id, name }) => (
                    <Col
                      xs={24}
                      sm={9}
                      md={9}
                      lg={8}
                      xl={6}
                      key={id}
                      className="mb-5"
                    >
                      <Checkbox
                        value={id}
                        checked={hasValueInList(selectedPermissions, 'id', id)}
                        onChange={() => onSelectPermission(id)}
                        disabled={!isEditing}
                      >
                        <LabelCheckbox>{name}</LabelCheckbox>
                      </Checkbox>
                    </Col>
                  ))}
                </Row>
              </Col>
            ))}
          </Card>
        </Col>
      ))}
    </Col>
  );
}

Notificacao.propTypes = {
  selectedPermissions: PropTypes.instanceOf(Array),
  onSelectPermission: PropTypes.func.isRequired,
  isEditing: PropTypes.bool,
};

Notificacao.defaultProps = {
  selectedPermissions: [],
  isEditing: false,
};
